import React from 'react';
import {
  Switch,
  Route,
  useRouteMatch,
} from 'react-router-dom';

import {
  PageTradesList,
  PageTrade,
} from '../pages/trades';

const RouteTrades = () => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route exact path={path}>
        <PageTradesList />
      </Route>
      <Route path={`${path}/:_id`}>
        <PageTrade />
      </Route>
    </Switch>
  );
};

export default RouteTrades;
